






















































































































import {Component, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class'
import BtnDefault from '@/components/UI/BtnDefault.vue';
import IClose from '@/components/icons/IClose.vue'
import IPhone from '@/components/icons/IPhone.vue'
import IEnvelope from '@/components/icons/IEnvelope.vue'
import IHelp from '@/components/icons/IHelp.vue'

const dialog = namespace('dialog')

@Component({
  components: {
    BtnDefault,
    IClose,
    IPhone,
    IEnvelope,
    IHelp
  }
})
export default class QuestionsModal extends Vue {
  @dialog.Getter('questionsModalShow') protected questionsModalShow: any
  @dialog.Mutation('SetQuestionsModalShow') protected SetQuestionsModalShow: any
  
  isEurope:boolean = false

  mounted() {
    this.isEurope = localStorage.getItem('region') != 'RU'
  }

  closeDialog() {
    this.SetQuestionsModalShow(false)
  }

  isEuropeContent(item:any, index:number) {
    return this.isEurope && item.icon == 'i-phone' && index != 0 ? '+49(0) 341 92 881 175' : item.content
  }

  isEuropeLink(item:any, index:number) {
    return this.isEurope && item.icon == 'i-phone' && index != 0 ? 'tel:+49034192881175' : item.link
  }


}
